import {FC, useEffect} from "react";
import {atom, selector, useRecoilState} from "recoil";
import {useNavigate} from "react-router-dom";
import {parse} from "query-string";
import {LoginContext} from "../../pages/LoginContext";
import {ReturnsPagePath} from "../../pages/restricted/returns/ReturnsPage";

export interface AppContext {
   shopId: string
   brandName?: string
   consumerId?: string
   consumerToken?: string
   wholeSaleActive?: boolean
   allowedCountry?: boolean
   locale?: string
   currency?: string
   shopCurrency?: string
   disableLogin?: boolean
   pos?: boolean
   circularPoints?: boolean
   multiLogin?: boolean
   lockEmail?: boolean
   headless: boolean
   requestPotentialsSupported: boolean
   requestPotentialTokens?: string[]
   tradeInComments: boolean
   tradeInPayoutEnabled: boolean
   tradeInPayoutPct: number
}

export const DefaultAccessContextData = {
   shopId: window.shopId || window.brandId,
   disableLogin: window.disableLogin || false,
   multiLogin: window.multiLogin || false,
   headless: window.headless || false,
   requestPotentialsSupported: false,
   tradeInComments: false,
   tradeInPayoutEnabled: false,
   tradeInPayoutPct: 0
};
export const AccessContextData = atom<AppContext>({
   key: 'AccessContextData',
   default: DefaultAccessContextData
})

export const LoggedIn = selector<boolean>({
   key: 'AccessContextLoggedIn',
   get: ({get}) => {
      const data = get(AccessContextData);
      return !!data.consumerId;
   }
})

export const FetchingPotentials = selector<boolean>({
   key: 'AccessContextFetchingPotentials',
   get: ({get}) => {
      const data = get(AccessContextData);
      return data.requestPotentialsSupported && (data.requestPotentialTokens === undefined || data.requestPotentialTokens.length > 0);
   }
})

export const AppContextProvider: FC<any> = ({children}) => {
   const [loginContext, setLoginContext] = useRecoilState(LoginContext)
   const navigate = useNavigate();

   const parsedQuery = parse(window.location.search);
   const loginParameter = parsedQuery.login;
   const preview = parsedQuery.preview === 'true';

   useEffect(() => {
      if (loginParameter) {
         window.history.replaceState(null, '', window.location.pathname)

         setLoginContext({
            accessToken: loginParameter as string,
            preview
         })
         navigate(ReturnsPagePath(), {
            replace: true
         });
      } else if (window.accessToken && window.accessToken !== loginContext.accessToken) {
         setLoginContext({
            accessToken: window.accessToken,
            preview
         })
         navigate(ReturnsPagePath(), {
            replace: true
         });
      }
   }, [navigate, loginParameter, setLoginContext, loginContext.accessToken, preview])

   return children
}
